import { useEffect, useRef, useState } from "react";
import { Settings } from "lucide-react";
import { useSearchParams } from "react-router";
import NotificationDropdown from "../components/header/NotificationDropdown";
import UserDropdown from "../components/header/UserDropdown";
import ConfigureSettings from "../components/settings/ConfigureSettings";

const AppHeader: React.FC = () => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [isLinkingNewAccount, setIsLinkingNewAccount] = useState(false);
  const [isNewAccountLinked, setIsNewAccountLinked] = useState(false);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key === "k") {
        event.preventDefault();
        inputRef.current?.focus();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    const linkingValue = searchParams.get("account-linked");

    if (!linkingValue) return;

    const isLinked = linkingValue === "true";

    setIsLinkingNewAccount(true);
    setIsNewAccountLinked(isLinked);
    setIsSettingsOpen(true);

    const newParams = new URLSearchParams(searchParams);
    newParams.delete("account-linked");

    setSearchParams(newParams, { replace: true });
  }, [searchParams, setSearchParams]);

  return (
    <div className="flex h-15 w-full">
      <div className="p-2">
        <img src="/images/logo/logo1.png" alt="Logo" width={120} height={30} />
      </div>

      <div
        className={`items-center justify-between w-full gap-4 px-5 py-4 lg:flex shadow-theme-md lg:justify-end lg:px-0 lg:shadow-none`}
      >
        <div className="flex items-center gap-2 2xsm:gap-3">
          <Settings
            className="text-gray-500 hover:cursor-pointer"
            onClick={() => setIsSettingsOpen(true)}
            size={20}
          />

          {isSettingsOpen && (
            <ConfigureSettings
              isLinkingNewAccount={isLinkingNewAccount}
              isNewAccountLinked={isNewAccountLinked}
              onClose={() => setIsSettingsOpen(false)}
            />
          )}
        </div>

        <div className="flex items-center gap-2 2xsm:gap-3">
          <NotificationDropdown />
        </div>

        <UserDropdown />
      </div>
    </div>
  );
};

export default AppHeader;
